module.exports = __webpack_public_path__ + "static/media/Location.9460c85a.svg";